import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "civil-resources",
  department: "Civil Engineering",
  short: "Civil",
  description: "student_resources for the Department of Civil Engineering.",
  resourceSet: "aiml",
 sections: [
    {
      title: "IA Syllabus",
      items: [
        {
          label: "IA Syllabus",
          href: "https://drive.google.com/drive/folders/1DRRzgYHGTJIiHtBaggmfGwPPlfTiC8Ye?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "4th Semester TimeTable",
          href: "/student_resources/CIVIL/TimeTable/4TH-TIME-TABLE.pdf",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "6th Semester TimeTable",
          href: "/student_resources/CIVIL/TimeTable/6TH-TIME-TABLE.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
      {
          label: "2nd & 4th Sem COE",
          href: "/student_resources/CIVIL/COE/ACADEMIC-CALENDAR-2ND-AND-4TH.pdf",
        },
        {
          label: "6nd & 8th Sem COE",
          href: "/student_resources/CIVIL/COE/ACADEMIC-CALENDAR-6TH-AND-8TH.pdf",
        },
    ] },
    {
      title: "Lab Manuals",
      items: [
        {
          label: "Lab Manual",
          href: "https://drive.google.com/drive/folders/123mzuNbXyMP5_FhWQQZ7RLfVMMNJy8mK?usp=drive_link",
        },
      ]
    },   
    {
        title: "Question Papers & Solutions",
        items: [
          {
            label: "Question Paper and Solution",
            href: "https://drive.google.com/drive/folders/13WhErOh6Di1FXmmVmfOKnmxQrb7kvyVS?usp=drive_link",
          },
        ],
      },
    // {
    //   title: "Add-On Subjects",
    //   items: [
    //     {
    //       label: "Add-On Course Syllabus",
    //       href: "/resources/student-resources/aiml/addon-course/4th-sem-add-on-1-syllabus.pdf",
    //     },
    //   ],
    // },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: " INTEGRATED LEGAL CASE ANALYSIS AND DOCUMENT GENERATION SYSTEM USING RETRIEVAL-AUGMENTED AI MODELS ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //     {
    //       label: " NETWORK TRAFFIC ANALYSIS FOR SECURITY ANOMALY ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-799.pdf",
    //     },
    //     {
    //       label: " CROWD SENSE: A REAL-TIME SYSTEM FOR CROWD ANALYTICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-883.pdf",
    //     },
    //     {
    //       label: " AI-DRIVEN MOBILE FORENSICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1145.pdf",
    //     },
    //     {
    //       label: " AI-BASED TEXT TO 3D MODEL GENERATOR",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1793-793.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "4th Semester 2025-26",
          href: "/student_resources/CIVIL/MentorMentee/4th-sem-mentee-25-26.pdf",
        },
        {
          label: "6th Semester 2025-26",
          href: "/student_resources/CIVIL/MentorMentee/6th-sem-Mentee-25-26.pdf",
        },
        {
          label: "8th Semester 2025-26",
          href: "/student_resources/CIVIL/MentorMentee/8th-sem-Mentee-25-26.pdf",
        },
      ],
    },
  ],
};

const CivilResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default CivilResources;
